import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: #F2F4F7;
  padding: 4rem 0 2.5rem;

  @media screen and (max-width: 768px) {
    padding: 3rem 0 2rem;
  }
`;

export const Title = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #1A1A1A;
  margin-bottom: 1.25rem;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0 0.75rem;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.75rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #1A73E8;
  }
`;

export const Extra = styled("section")`
  background: rgb(241, 242, 243);
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding: 2.5rem 0;
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
  background: rgba(26, 115, 232, 0.08);
  padding: 0.5rem 1rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.15);
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 4px 16px rgba(26, 115, 232, 0.3);
    background: rgba(26, 115, 232, 0.14);
  }
`;

export const Para = styled("div")`
  color: #1A1A1A;
  font-size: 14px;
  width: 70%;
`;

export const Large = styled(Link)`
  font-size: 16px;
  color: #000;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: capitalize;
  line-height: 24px;
  display: block;
  margin-bottom: 0.625rem;
  transition: all 0.3s ease-in-out;
  max-width: max-content;

  &:hover {
    color: #00D4FF;
    text-underline-position: under;
    text-decoration: #00D4FF wavy underline;
  }
`;

export const Chat = styled("p")`
  color: #18216d;
  max-width: fit-content;
  border-bottom: 1px solid #18216d;
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    border-bottom: 1px solid #00D4FF;
    color: #00D4FF;
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const Language = styled("h4")`
  font-size: 22px;
  text-transform: capitalize;
  color: #1A1A1A;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const Label = styled("label")`
  font-size: 22px;
  text-transform: capitalize;
  color: #1A1A1A;
  display: block;
  margin-bottom: 2rem;
  font-family: "Motiva Sans Bold", serif;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 85px;
`;
